import styled from 'styled-components'
import { rem } from 'polished'
import Sheet from 'components/utils/Sheet'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import {
  CANVAS_CONTENT_WIDTH,
  CANVAS_HORIZONTAL_PADDING,
  CANVAS_NARROW_BREAKPOINT,
  CANVAS_NARROW_CONTENT_WIDTH,
  CANVAS_NARROW_HORIZONTAL_PADDING,
} from './constants'

export const CanvasContainer = styled.div`
  container-name: chat-itinerary-canvas;
  container-type: inline-size;
  height: 100%;
`

export const ScrollableContainer = styled.div`
  --itinerary-canvas-width: ${rem(CANVAS_CONTENT_WIDTH)};
  --itinerary-canvas-padding: var(--trip-plan-canvas-padding, ${rem(CANVAS_HORIZONTAL_PADDING)});
  --itinerary-stop-image-size: var(--trip-plan-canvas-stop-image-size, ${rem(72)});
  --itinerary-item-card-padding: ${rem(16)};
  --itinerary-preview-tile-size: ${rem(40)};
  --itinerary-section-padding: var(--trip-plan-canvas-section-padding, ${rem(20)});

  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
  scroll-padding-top: ${rem(81)};
  width: 100%;
  background: var(--trip-plan-canvas-background, ${props => props.theme.palette.neutral.surface.lightBackground});

  @container chat-itinerary-canvas (max-width: ${rem(CANVAS_NARROW_BREAKPOINT)}) {
    --itinerary-canvas-width: ${rem(CANVAS_NARROW_CONTENT_WIDTH)};
    --itinerary-canvas-padding: var(--trip-plan-canvas-narrow-padding, ${rem(CANVAS_NARROW_HORIZONTAL_PADDING)});
    --itinerary-stop-image-size: var(--trip-plan-canvas-stop-image-size, ${rem(72)});
    --itinerary-item-card-padding: ${rem(12)};
    --itinerary-preview-tile-size: ${rem(32)};
    --itinerary-section-padding: var(--trip-plan-canvas-section-padding, ${rem(16)});
  }
`

// Surfaces that render sections edge to edge (the mobile timeline) zero the inline
// padding here and let each section own its inset instead.
export const CanvasContent = styled.div`
  box-sizing: border-box;
  padding-block-start: ${rem(8)};
  padding-block-end: var(--trip-plan-canvas-content-padding-block-end, ${rem(28)});
  padding-inline: var(--trip-plan-canvas-content-padding, var(--itinerary-canvas-padding));
  width: 100%;
`

// Tracks the loaded stop sheet's chrome so the skeleton doesn't change shape on hydrate.
export const SkeletonStopSheet = styled(Sheet)`
  max-width: var(--itinerary-canvas-width);
  width: 100%;
  padding: var(--itinerary-section-padding, ${rem(20)});
  border-radius: var(--trip-plan-canvas-section-radius, ${props => props.theme.borderRadius.L});

  &.bordered {
    border-width: var(--trip-plan-canvas-section-border-width, 1px);
  }
`

export const FullWidthLoadingBox = styled(LoadingBox)`
  width: 100%;
`

// Gap around a transport leg. Tighter than ItemSpacer, which separates stops that
// aren't joined by transport.
export const TransportSpacer = styled.div`
  max-width: var(--itinerary-canvas-width);
  width: 100%;
  height: ${rem(24)};
`

export const ItemSpacer = styled.div`
  height: ${rem(40)};
`

export const StopContentWrapper = styled.div`
  max-width: var(--itinerary-canvas-width);
  width: 100%;
`
